<template>
  <main-template>
    <v-row>
      <v-col>
        <span id="matriculas-title" class="text-h4">Matriculas</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div id="matriculas-actions" class="d-flex mb-2 justify-space-between align-center">
          <v-btn
            v-if="$can('matriculas.matricular')"
            id="create-matricula-btn"
            color="success"
            @click="criarMatricula"
            class="mr-2"
            >Criar Matricula</v-btn
          >
          <div class="d-flex align-center" style="gap: 12px; flex: 1; justify-content: flex-end">
            <v-switch
              v-model="mostrarExcluidos"
              label="Mostrar Excluídos"
              color="primary"
              class="mt-0 pt-0"
              dense
              hide-details
              inset
            ></v-switch>
            <v-text-field
              id="search-matriculas"
              v-model="search"
              class="search-input"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              solo
              autofocus
              dense
              single-line
              hide-details
              style="max-width: 400px"
            />
          </div>
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          id="matriculas-table"
          :headers="table.headers"
          :items="matriculasList"
          :loading="carregandoMatriculas"
          :items-per-page="matriculasList.length"
          :custom-filter="dataTableFilter"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody
              id="matriculas-table-body"
              name="scroll-x-transition"
              is="transition-group"
              duration="150"
            >
              <tr
                :id="`matricula-row-${matricula.id}`"
                color="primary"
                :class="matricula.estaDeletado ? ['deleted'] : []"
                v-for="matricula of items"
                :key="matricula.id"
              >
                <td :id="`matricula-id-${matricula.id}`">{{ matricula.id }}</td>
                <td :id="`matricula-codigo-${matricula.id}`">
                  <strong>{{ matricula.aluno.codigo ? matricula.aluno.codigo : "- - -" }}</strong>
                </td>
                <td :id="`matricula-nome-${matricula.id}`">
                  {{ matricula.aluno.nomecompleto }}
                  <e-tooltip-exclusao :exclusoes="matricula.exclusoes_count" />
                </td>
                <td :id="`matricula-turma-${matricula.id}`" class="text-left">
                  {{ matricula.turma.descricao }} [{{
                    matricula.serie ? matricula.serie.descricao : "- - -"
                  }}]
                </td>
                <td :id="`matricula-situacao-${matricula.id}`" class="text-left">
                  <v-chip
                    :id="`matricula-situacao-chip-${matricula.id}`"
                    :color="matricula.estaDeletado ? 'red accent-4' : 'success'"
                    outlined
                  >
                    {{
                      matricula.estaDeletado
                        ? "EXCLUÍDO"
                        : ["REP", "AP"].includes(matricula.situacao)
                        ? "CURSANDO"
                        : matricula.situacao || "- - -"
                    }}
                  </v-chip>
                </td>
                <td :id="`matricula-acoes-${matricula.id}`">
                  <v-btn
                    v-if="matricula.estaDeletado"
                    :id="`restaurar-matricula-btn-${matricula.id}`"
                    x-small
                    color="green accent-4"
                    dark
                    @click="restaurarMatricula(matricula)"
                  >
                    <v-icon left>mdi-restore</v-icon>
                    RESTAURAR
                  </v-btn>
                  <div v-else :id="`matricula-acoes-menu-${matricula.id}`" class="text-left">
                    <v-menu :close-on-content-click="false" :nudge-width="100" top offset-x>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :id="`matricula-acoes-btn-${matricula.id}`"
                          x-small
                          color="indigo"
                          dark
                          v-bind="attrs"
                          v-on="on"
                        >
                          AÇÕES
                        </v-btn>
                      </template>
                      <v-card
                        :id="`matricula-acoes-card-${matricula.id}`"
                        class="mx-auto"
                        max-width="300"
                      >
                        <v-list>
                          <v-list-item>
                            <v-list-item-avatar color="primary">
                              <v-list-item-title style="color: #fff">{{
                                matricula.aluno.nomecompleto
                                  ? matricula.aluno.nomecompleto.substring(0, 2).toUpperCase()
                                  : "- - -"
                              }}</v-list-item-title>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                matricula.aluno.nomecompleto
                                  ? matricula.aluno.nomecompleto
                                  : "- - -"
                              }}</v-list-item-title>
                              <v-list-item-subtitle
                                >{{
                                  matricula.turma.descricao ? matricula.turma.descricao : "- - -"
                                }}
                                /
                                {{ matricula.aluno.codigo ? matricula.aluno.codigo : "- - -" }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-list>
                          <v-list-item-group
                            v-if="
                              (!matricula.estaDeletado &&
                                $constants.situacaoMatriculaCursandoRecebidaReprovado.includes(
                                  matricula.situacao
                                )) ||
                              $constants.situacaoMatriculaAprovado.includes(matricula.situacao)
                            "
                            color="primary
                            "
                          >
                            <v-list-item
                              :id="`declaracao-curso-${matricula.id}`"
                              @click="() => carteirinhaEstudante(matricula)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-file-pdf</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Carteira de Estudante</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              :id="`declaracao-curso-${matricula.id}`"
                              @click="() => declaracaoCurso(matricula)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-file-pdf</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Declaração de curso</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                          <v-list-item-group
                            v-if="
                              !matricula.estaDeletado &&
                              $constants.situacaoMatriculaAprovado.includes(matricula.situacao)
                            "
                            color="primary
                            "
                          >
                            <v-list-item
                              :id="`declaracao-conclusao-${matricula.id}`"
                              @click="() => declaracaoConclusao(matricula)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-file-pdf</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Declaração de conclusão</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                          <v-list-item-group
                            v-if="
                              (!matricula.estaDeletado &&
                                $constants.situacaoMatriculaCursandoRecebidaReprovado.includes(
                                  matricula.situacao
                                )) ||
                              $constants.situacaoMatriculaAprovado.includes(matricula.situacao) ||
                              $constants.situacaoMatriculaInativoFalecidoAbandonoCancelado.includes(
                                matricula.situacao
                              )
                            "
                            color="primary
                            "
                          >
                            <v-list-item
                              :id="`ficha-matricula-${matricula.id}`"
                              @click="() => fichaDeMatricula(matricula)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-file-pdf</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Ficha de matricula</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                          <v-list-item-group v-if="!matricula.estaDeletado" color="primary">
                            <v-list-item
                              :id="`encaminhamento-escolar-${matricula.id}`"
                              @click="() => updateMatricula(matricula)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-file-pdf</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Encaminhamento escolar</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                        <v-divider></v-divider>
                        <v-list>
                          <v-list-item-group
                            v-if="!matricula.estaDeletado && $can('matriculas.deletar')"
                            color="primary"
                          >
                            <v-list-item
                              :id="`deletar-matricula-${matricula.id}`"
                              @click="() => deletarMatricula(matricula)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-trash</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Apagar matricula</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                        <v-divider></v-divider>
                      </v-card>
                    </v-menu>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <e-paginate
          id="matriculas-pagination"
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="listarMatriculas"
          :search="search"
        ></e-paginate>
        <e-modal-encaminhamento-escolar
          id="modal-encaminhamento-escolar"
          :dialog="dialog"
          :matricula="matricula"
          :professoresList="professoresList"
          @updateModal="updateModal($event)"
        ></e-modal-encaminhamento-escolar>
      </v-col>
    </v-row>

    <v-dialog v-model="showModal" max-width="30%">
      <EModalCarteirinhaVisualizar :data="data" />
    </v-dialog>
    <!-- <div style="width: 500px;">
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal"></div>
      <div v-if="showModal" class="modal-container" style="width: 500px;">
        <div class="modal-header">
          <h3>Carteirinha do Estudante</h3>
          <button class="btn-close" @click="closeModal" aria-label="Fechar">
            <v-icon small>close</v-icon>
          </button>
        </div>

        <EModalCarteirinhaVisualizar :matricula="matricula"/>
        <div class="modal-body">
          <button class="btn btn-download" @click="carteirinhaEstudanteBaixar">
            <v-icon small style="margin-right: 8px">fa-solid fa-download</v-icon>
            Baixar
          </button>
        </div>
      </div>
    </div> -->
  </main-template>
</template>
<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import Matricula from "@/Models/Matricula";
import { $constants } from "../../plugins/constants";
import EModalCarteirinhaVisualizar from "../../components/Carteirinha/EModalCarteirinhaVisualizar.vue";

export default {
  components: {
    EModalCarteirinhaVisualizar,
  },
  data() {
    return {
      logo: "../../",
      carregandoMatriculas: false,
      dialog: false,
      dataTableFilter,
      matricula: {},
      professoresList: [],
      search: "",
      mostrarExcluidos: false,
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      data: null,
      showModal: false,
      carteirinha_file: null,
      carteirinhaUrl: null,
      imageUrl: null,
      matriculasList: [],
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Código", value: "codigo" },
          { text: "Aluno", value: "nomeAluno" },
          { text: "Turma", value: "nomeTurma" },
          { text: "Situação", value: "situacao" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  async mounted() {
    this.carregandoMatriculas = true;
    this.$loaderService.open("Carregando Matriculas");
    this.listarMatriculas(this.pageNumber);
    this.carregandoMatriculas = false;
    this.$loaderService.close();
  },
  watch: {
    carregandoMatriculas(value) {
      if (value && this.matriculasList.length === 0) {
        this.$loaderService.open("Carregando matriculas");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val.length > 2) {
        await this.listarMatriculas(0, val);
      }
      if (!val) {
        await this.listarMatriculas(0);
      }
    },
    async mostrarExcluidos() {
      await this.listarMatriculas(0);
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
      if (this.carteirinhaUrl) {
        window.URL.revokeObjectURL(this.carteirinhaUrl);
        this.carteirinhaUrl = null;
      }
    },
    updateModal(value) {
      this.dialog = !this.dialog;
    },
    gerarFichaDeMatriculaEncaminhamentoEscolar(value) {
      this.professoresList = [];
      this.dialog = false;
    },
    async listarMatriculas(pageNumber, query = null) {
      this.carregandoMatriculas = true;
      try {
        const response = await this.$services.matriculasService.syncAll(
          pageNumber,
          query,
          this.mostrarExcluidos
        );
        this.matriculasList = await response.data.map((matricula) => new Matricula(matricula));
        this.paginate = response;
      } catch (error) {
        this.$handleError(error);
      }
      this.carregandoMatriculas = false;
    },
    criarMatricula() {
      this.$router.push({ name: "matriculas.create" });
    },
    editarMatricula(matricula) {
      this.$router.push({
        name: "matriculas.edit",
        params: { matricula_id: matricula.id },
      });
    },
    async deletarMatricula(matricula) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta matricula?",
        confirmationCode: matricula.id,
        confirmationMessage: `Por favor, digite <strong>${matricula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Solicitando deleção da Matrícula");
              try {
                await this.$services.matriculasService.solicitarDelecaoMatricula(matricula);
                this.$toast.success("Solicitação enviada com sucesso");
                await this.listarMatriculas();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
    restaurarMatricula(matricula) {
      this.$modals.danger({
        title: "Atenção!",
        message:
          "Tem certeza que deseja restaurar esta matrícula? Ela voltará a ficar ativa no sistema.",
        confirmationCode: matricula.id,
        confirmationMessage: `Por favor, digite <strong>${matricula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Restaurando a Matrícula");
              try {
                await this.$services.matriculasService.restaurarMatricula(matricula);
                this.$toast.success("Matrícula restaurada com sucesso");
                await this.listarMatriculas(this.pageNumber);
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "success",
              small: true,
            },
          },
        ],
      });
    },
    recuperarMatricula(matricula) {
      // Deprecated - redirect to new method
      this.restaurarMatricula(matricula);
    },
    async declaracaoConclusao(matricula) {
      this.$loaderService.open("Baixando declaração");
      try {
        await this.$services.relatoriosService.declaracaoConclusao(matricula.id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async updateMatricula(matricula) {
      this.$loaderService.open("Carregando dados...");
      try {
        this.professoresList = await this.$services.professoresService.listarProfessoresDaTurma(
          matricula.turma_id
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
        this.matricula = matricula;
        this.dialog = true;
      }
    },
    async fichaDeMatricula(matricula) {
      this.$loaderService.open("Baixando ficha de matricula");
      try {
        await this.$services.relatoriosService.fichaDeMatricula(matricula.id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async declaracaoCurso(matricula) {
      this.$loaderService.open("Baixando declaração");
      try {
        await this.$services.relatoriosService.declaracaoCurso(matricula.id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async carteirinhaEstudante(matricula) {
      try {
        this.$loaderService.open("Gerando carteirinha estudantil, por favor aguarde...");
        this.matricula = matricula;
        this.data = await this.$services.relatoriosService.carteirinhaVisualizacao(matricula.id);
        this.showModal = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async carteirinhaEstudanteBaixar() {
      try {
        this.$loaderService.open("Baixando carteirinha");
        this.showModal = false;
        await this.$services.relatoriosService.carteirinhaEstudanteBaixar(this.matricula.id);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 400px;
  z-index: 9999;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
  background-color: #f9f9f9;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.btn-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 20px;
  padding: 4px;
  transition: color 0.2s;
}

.btn-close:hover {
  color: #333;
}

.modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-print {
  background-color: #1976d2;
  color: white;
}

.btn-print:hover {
  background-color: #1565c0;
}

.btn-download {
  background-color: #4caf50;
  color: white;
}

.btn-download:hover {
  background-color: #388e3c;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

tr.deleted {
  background-color: #ffebee;
}

tr.deleted td {
  text-decoration: line-through;
  color: #000000;
}

tr.deleted .v-chip {
  text-decoration: none;
}
</style>
